import {
  EmbeddableComponent,
  ComponentOptions,
} from '@chargify/embeddable-component';

import App from './App';

import { defaultSettings } from './settings';
import { SubscriptionManagerLoader } from './components';
import { ComponentSettingsClient } from './types';

class SubscriptionsManager extends EmbeddableComponent {
  constructor({
    i18n,
    componentsTheme,
    sessionManager,
    dataAccess,
  }: ComponentOptions) {
    super({ i18n, componentsTheme, sessionManager, dataAccess });
  }

  render(
    container: string | HTMLElement,
    componentSettings?: ComponentSettingsClient
  ) {
    const settings = componentSettings || defaultSettings;
    super.renderComponent<ComponentSettingsClient>(
      container,
      App,
      settings,
      SubscriptionManagerLoader
    );
  }
}
export default SubscriptionsManager;
